import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'kh-banner',
    styleUrls: ['./banner.component.less'],
    templateUrl: './banner.component.html',
    standalone: false
})
export class BannerComponent implements OnInit {
  public visible = true;

  public constructor() { }

  ngOnInit(): void {
  }

  public toggleVisibility(): void {
    this.visible = !this.visible;
  }
}
